import React from 'react';
import { StyledIframe } from './style';

const FootPrintWebView = ({ url }) => {
  return (
    <div>
      <StyledIframe src={url}></StyledIframe>
    </div>
  );
};

export default FootPrintWebView;
